<template>
  <!-- <div class="bg-services"> -->
    <!-- <div class="services-mob"> -->
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <ul class="choose-plan">
              <li :class="{active: changePlan == 'b2c'}" @click="changePlan = 'b2c'">
                Para Você
              </li>
              <li :class="{active: changePlan == 'b2b'}" @click="changePlan = 'b2b'">
                Para Sua Empresa
              </li>
              <li :class="{active: changePlan == 'vpo'}" @click="changePlan = 'vpo'">
                Vale-pedágio
              </li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h3 class="bold margin-b0 margin-t30" v-if="changePlan == 'vpo'">TAG Exclusiva para VPO: Pensou Vale-pedágio, pensou Move Cargo.</h3>
            <h3 class="bold margin-b0 margin-t30" v-else>PLANOS</h3>

            <p  v-if="changePlan == 'b2c'">Temos dois planos, com certeza um deles é ideal para você, é só escolher:</p>
            <p  v-else-if="changePlan == 'vpo'">Totalmente digital, <b>SEM CUSTO</b> e fácil de usar.</p>
            <p  v-else>Temos três planos, com certeza um deles é ideal para você, é só escolher:</p>

            <b2c class="margin-t20" type="adhesion" v-if="changePlan == 'b2c'"></b2c>
            <vpo class="margin-t20" type="adhesion" v-else-if="changePlan == 'vpo'"></vpo>
            <b2b class="margin-t20" type="adhesion" v-else></b2b>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-xs-12">
            <h3 class="title">Serviços</h3>
            <hr class="h-rule-yellow">
            <hr class="h-rule-side-yellow">
          </div>
        </div>

        <div class="row margin-t10">
          <div class="col-xs-12 margin-b10">
            Serviços de passagem automática de pedágios <b>para você</b>.
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-center margin-b20">
            <router-link to="/servicos-b2c" class="btn btn-primary btn-large" tag="button">
              Ver planos para você
            </router-link>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 margin-b10 margin-t20">
            Serviços de passagem automática de pedágios <b>para empresas</b>.
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-center margin-b20">
            <router-link to="/servicos-b2b" class="btn btn-warning btn-large" tag="button">
              Ver planos para empresas
            </router-link>
          </div>
        </div> -->

      </div>
    <!-- </div> -->
  <!-- </div> -->
</template>

<style lang="scss" scoped>
  .bg-services {
    margin: -100px -20px -50px;
  }

  .img-services {
    background-image: url(../../assets/img/img-services.svg);
  }

  .services-mob {
    display: none;
  }

  .btn-large,
  .btn-large:active,
  .btn-large:focus,
  .btn-large:hover {
    padding: 10px 30px;
  }

  .choose-plan {
    margin-top: 20px;
    li {
      position: relative;
      display: inline-block;
      width: 33.33%;
      color: #613A7D;
      background-color: #F2F2F2;
      padding: 10px 5px;
      text-align: center;
      font-weight: bold;
      font-size: 1.5em;
      cursor: pointer;
      border-radius: 0;
      &:first-child {
        float: left;
        -webkit-border-radius: 10px 0 0 10px;
        border-radius: 10px 0 0 10px;
      }
      &:last-child {
        float: right;
        -webkit-border-radius: 0 10px 10px 0;
        border-radius: 0 10px 10px 0;
      }
      &.active {
        color: white;
        background: #613A7D;
        &::after {
          top: 100%;
        	left: 50%;
        	border: solid transparent;
        	content: " ";
        	height: 0;
        	width: 0;
        	position: absolute;
        	pointer-events: none;
        	border-color: rgba(97, 58, 125, 0);
        	border-top-color: #613A7D;
        	border-width: 15px;
        	margin-left: -15px;
        }
      }
    }
    li:hover {
      background-color: #E5E5E5;
    }
    li:hover.active {
      background-color: #613A7D;
      cursor: default;
    }
  }

  @media screen and (max-width: 656px) {   // 479px
    .choose-plan li {
      min-height: 80px;
      justify-content: center;
    }
    .choose-plan li:first-child {
     padding: 25px 5px;
     display: flex;
    }
    .choose-plan li:last-child {
     padding: 25px 5px;
     display: flex;
    }
  }

  @media screen and (max-width: 699px) {
    .services-mob {
      display: block;
      padding: 50px 20px 50px;
    }
  }

  @media only screen and (max-width: 900px) {
    .bg-services {
      margin: -50px -20px -50px;
    }
  }
</style>

<script>
import b2b from "./plans/b2b.vue"
import b2c from "./plans/b2c.vue"
import vpo from "./plans/vpo.vue"

export default {
  data() {
    return {
      changePlan: 'b2c'
    }
  },
  components: {b2b, b2c, vpo}
}
// const baseSvg = require('!!raw-loader!../../assets/img/img-services.svg');
//
// export default {
//   data() {
//     return {}
//   },
//
//   mounted() {
//     let vm = this;
//     let svg = $(baseSvg);
//     svg.appendTo(this.$el);
//
//   }
// }

</script>



// WEBPACK FOOTER //
// services.vue?33e3afed